import { FC } from 'react';
import { css } from '@emotion/react';
import { Info } from '@phosphor-icons/react';
import { Typography, TypographyProps } from 'client/components/Typography';

const helpStyle = css`
  position: relative;
  margin-top: 0.5rem;
  margin-bottom: 1rem;
  padding-left: 1.4rem;

  .MuiFormControl-root + & {
    margin-top: -0.5rem;
  }
`;

const iconStyle = css`
  position: absolute;
  left: 0;
  margin-top: 2px;
  opacity: 0.8;
`;

export const Help: FC<TypographyProps> = ({ children, ...other }) => (
  <Typography variant="body2" css={helpStyle} {...other}>
    <Info size={16} weight="bold" css={iconStyle} />
    {children}
  </Typography>
);
